<app-issue-listing-sidepanel [isShown]="isListingShown"
  (sidebarStateChange)="setSidebarState($event)">
</app-issue-listing-sidepanel>
<div class="sidenav" *ngIf="sidebarState">
  <div class="side-panel">

    <div class="d-sm-block d-md-none">
      <app-logout-modal></app-logout-modal>
    </div>

    <div class="row" *ngIf="isIssuer">
      <div class="col-md-10 offset-md-1 col-sm-10 offset-sm-1">
        <button id="show-create-cp-issue-button" class="btn btn-outline-secondary btn-sm btn-block mt-8 mb-6 new-issue-btn"
          routerLink="/issuer/new-issue" routerLinkActive="active">New Issue <span class="plusIcon">+</span></button>
      </div>
    </div>
    <ul>
      <li *ngFor="let link of linksToShow">
        <a id="{{link.name.toLowerCase().split(' ').join('-')}}" [routerLink]="link.routerLink"
          routerLinkActive="active flash-img">{{link.name}}</a>
      </li>
      <li *ngIf="isIssuer" id="market-listing-sidenav" class="cursor-pointer" (click)="showMarketListings()">
        <a>Listing Documents</a>
      </li>
      <li *ngIf="isAdmin && !isInvestorOnlyAdmin" id="upload-letterhead-sidenav" class="cursor-pointer"
        (click)="uploadLetterhead()">
        <a>Upload Letterhead</a>
      </li>
    </ul>
  </div>
</div>

<div class="sideNavStyle_1" id="test-signing-urls" *ngIf="signingurls?.length">
  <div id="test-sign-url-{{urlIndex}}" *ngFor="let signingurl of signingurls; let urlIndex = index;">
    {{ signingurl }}
  </div>
</div>

<footer>
  <small class="copyrightText">Powered by ICICI Bank</small>
</footer>